import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import CreateApp from './CreateApp';
import SekerApp from './SekerApp';
import ColorTheme from './ColorTheme';

// import registerServiceWorker from './registerServiceWorker';
import MobileDetect from 'mobile-detect';
import BrowserDetect from 'browser-detect';
import WebglDetect from './Utils/WebglDetect';

global.LogEvent = console.log

var md = new MobileDetect(window.navigator.userAgent);
global.isMobile = md.mobile();
global.browser = BrowserDetect()["name"];
global.webGlSupported = WebglDetect();
// console.log("global.browser: " + global.browser);
global.isMale = true; //TODO: receive from server

// global.URL = "http://localhost:3850"	
// global.URL = "http://192.168.252.197:3850"
global.isStagging = false
global.URL = "https://sc.kayma.com"
global.SERVER_URL = "https://dc.kayma.com"
global.CACHE_URL = "https://hc.kayma.com"
if(window.location.host.indexOf('staging-survey') > -1) {
	global.isStagging = true
	global.URL = "https://seker-creator-staging.herokuapp.com"
	global.SERVER_URL = "https://maagar-haseker-staging.herokuapp.com"
	global.CACHE_URL =  "https://seker-cache-stag.herokuapp.com"
}
console.log("STARTING APP")

function parseQuery(queryString) {
	var query = {};
	var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
	for (var i = 0; i < pairs.length; i++) {
		var pair = pairs[i].split('=');
		if(pair[0]) {
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
		}
	}
	return query;
}

global._getStrWithQueryVar = function(txt) {
	let retTxt = txt;
	Object.keys(global._queryDict).forEach(k => {
		const regex = new RegExp("{{" + k + "}}", "g");
		retTxt = retTxt.replace(regex, global._queryDict[k])
	})
	return retTxt
}

const hashPart = window.location.hash.split('?')
let sekerKey = undefined;
let userId = undefined;
if(hashPart[0]) {
	const sp = hashPart[0].split('/')
	sekerKey = sp[1]
	userId = sp[2]	
}
global._queryDict = {}
if(hashPart[1]) {
	global._queryDict = parseQuery(hashPart[1])
}

ReactDOM.render(<SekerApp sekerKey={sekerKey} userId={userId}/>, document.getElementById('root'));

const spBefore = window.location.hash.split('/')
window.onhashchange = () => {
	const spChange = window.location.hash.split('/')
	if(spBefore[1] != spChange[1]) {
		window.location.reload()
	}
}


// WEBPACK FOOTER //
// ./src/index.js